import { render, staticRenderFns } from "./NewPlace.vue?vue&type=template&id=0210316a&"
import script from "./NewPlace.vue?vue&type=script&lang=js&"
export * from "./NewPlace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports